import { render, staticRenderFns } from "./RequestTOTPReset.vue?vue&type=template&id=38b1d7c8&"
import script from "./RequestTOTPReset.vue?vue&type=script&lang=js&"
export * from "./RequestTOTPReset.vue?vue&type=script&lang=js&"
import style0 from "./RequestTOTPReset.vue?vue&type=style&index=0&id=38b1d7c8&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports